import React, {useEffect, useRef, useState} from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {useTranslation} from "react-i18next";
import SeverityLevel from "../../../components/settings/projectSetting/errorTopology/SeverityLevel";
import ErrorCategories from "../../../components/settings/projectSetting/errorTopology/ErrorCategories";
import ErrorType from "../../../components/settings/projectSetting/errorTopology/ErrorType";
import {useNavigate} from "react-router-dom";
import $ from "jquery";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";

export default function ErrorTopology() {
  const scrollRef = useRef(null);
  const {t} = useTranslation();
  const translate = t;
  const [activeTab, setActiveSection] = useState("severitylevel");
  const navigate = useNavigate();

  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Error topology', url:''},
  ];
  useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="error-topology-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button
                    aria-label="back"
                    onClick={() => navigate("/settings")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                  </button>
                  <span>Back to Settings</span>
                </div>
                <h3 className="flex">
                  Error Topology
                </h3>
                <span>
                  Add, delete, enable, disable custom severity, error category
                  and error type 
                </span>
              </div>
              <div className="listing-tab-block flex">
                <ul className="listing-tab-link flex" role="tablist">
                  <li role="none">
                    <button
                     role="tab"
                     aria-label={activeTab === "severitylevel" ? "Current tab, severitylevel" : "severitylevel"}
                     aria-selected={activeTab === "severitylevel" ? "true" : "false"}
                      className={activeTab === "severitylevel" ? "active" : ""}
                      onClick={() => setActiveSection("severitylevel")}
                    >
                      Severity Level
                    </button>
                  </li>
                  <li role="none">
                    <button
                     role="tab"
                     aria-label={activeTab === "ErrorCategories" ? "Current tab, ErrorCategories" : "ErrorCategories"}
                     aria-selected={activeTab === "ErrorCategories" ? "true" : "false"}
                      className={
                        activeTab === "ErrorCategories" ? "active" : ""
                      }
                      onClick={() => setActiveSection("ErrorCategories")}
                    >
                      Error Categories
                    </button>
                  </li>
                  <li role="none">
                    <button
                     role="tab"
                     aria-label={activeTab === "ErrorType" ? "Current tab, ErrorType" : "ErrorType"}
                     aria-selected={activeTab === "ErrorType" ? "true" : "false"}
                      className={activeTab === "ErrorType" ? "active" : ""}
                      onClick={() => setActiveSection("ErrorType")}
                    >
                      Error Type
                    </button>
                  </li>
                </ul>
              </div>
              <div className="white-bg">
                <div
                  className={
                    activeTab === "severitylevel"
                      ? "errortopology-tab-content show"
                      : "hide"
                  }
                >
                  {activeTab === "severitylevel" ? <SeverityLevel /> : null}
                </div>

                <div
                  className={
                    activeTab === "ErrorCategories"
                      ? "errortopology-tab-content show"
                      : "hide"
                  }
                >
                  {activeTab === "ErrorCategories" ? <ErrorCategories /> : null}
                </div>

                <div
                  className={
                    activeTab === "ErrorType"
                      ? "errortopology-tab-content show"
                      : "hide"
                  }
                >
                  {activeTab === "ErrorType" ? <ErrorType /> : null}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
